import { render, staticRenderFns } from "./PropertyLandlords.vue?vue&type=template&id=72969ffc&scoped=true"
import script from "./PropertyLandlords.vue?vue&type=script&lang=js"
export * from "./PropertyLandlords.vue?vue&type=script&lang=js"
import style0 from "./PropertyLandlords.vue?vue&type=style&index=0&id=72969ffc&prod&lang=css"
import style1 from "./PropertyLandlords.vue?vue&type=style&index=1&id=72969ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72969ffc",
  null
  
)

export default component.exports